import { render, staticRenderFns } from "./SharedEnquirySettings.vue?vue&type=template&id=23805233&scoped=true"
import script from "./SharedEnquirySettings.vue?vue&type=script&lang=js"
export * from "./SharedEnquirySettings.vue?vue&type=script&lang=js"
import style0 from "./SharedEnquirySettings.vue?vue&type=style&index=0&id=23805233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23805233",
  null
  
)

export default component.exports